let animalsService = function animalsServiceFn () {
  return [];
};

export default animalsService;



/** WEBPACK FOOTER **
 ** ./services/animals/animals.service.js
 **/